'use strict';

require('fancybox');
require('../company/publications/CompanyPublicationFileService.js');
require('../company/categories/CompanyCategoryService.js');
require('../company/CompanyService.js');
require('../company/groups/CompanyGroupService.js');
require('../company/users/CompanyUserService.js');
require('../company/user-roles/CompanyUserRoleService.js');
require('../config.js');

function CompanyGuestCtrl(
  $scope,
  customerPortals,
  $state,
  $stateParams,
  $timeout,
  $modal,
  $window,
  config,
  company,
  categories,
  userInformation,
  info,
  role,
  userGroups,
  CompanyCategoryService,
  CompanyPublicationFileService,
  CompanyService
  ) {
  if (userInformation && userInformation.features && userInformation.features.denyLoginOnWeb) {
    $state.go('403', {}, { location: false });
  }
  $scope.publicationQuery = {
    groupId: '',
    categoryId: '',
    tags: [],
    page: 1
  };
  $scope.role = role;

  if ($scope.role !== null || ($scope.role && $scope.role.template !== null)) {
    angular.forEach($scope.role.menus, function(v){
      var hasSub = $scope.role.menus.some(function(m){
        return m.parentId === v.id;
      });

      if (hasSub) {
        v.hasSub = true;
      }
    });
  }
  
  $scope.companyId       = $stateParams.companyId;
  $scope.categoryActive  = false;
  $scope.categories      = categories;
  $scope.apiBase = config.apiBase;
  $scope.userGroups = userGroups;

  function checkPermissionGroup(group) {
    if (!group) {
      group = [];
    }
  
    if (group.length === 0) {
      return true;
    }
    
    var match = false;
    angular.forEach(group, function(val){
      if (!match) {
        match = $scope.userGroups.some(function(g){
          return g.id === val.id;
        });
      }
    });
    return match;
  }

  if ($scope.role && $scope.role.template !== undefined) {
    angular.forEach($scope.role.links, function(v){
      v.show = true;
      if (v.guestLink.indexOf(config.appBase) !== -1) {
        if (!angular.isArray(v.groups)) {
          v.group = [];
        }
        if (!checkPermissionGroup(v.groups)) {
          v.show = false;
        }
      }
    });
  } 

  $scope.isHideComment = userInformation.hide_comments;

  $scope.customerPortals = customerPortals;

  $scope.currency = 'sek';

  $scope.info = info;

  $scope.viewPublicationDetail = function(companyId, publication) {
    var route;
    switch (publication.type) {
      case 'FOLDER':
        route = 'root.company-guest.folder.detail';
        break;
      case 'ALBUM':
        route = 'root.company-guest.album.detail';
        break;
      case 'NOTE':
        route = 'root.company-guest.note.detail';
        break;
      case 'FORM':
        route = '';
        if (
          publication.features.formActived === "false" ||
          !!publication.features.formActived === false || !publication.features
        ) {
          window.location.href = '/forms/companies/'+companyId+'/publications/'+publication.id+'/detail';
        }else{
          window.location.href = '/forms/companies/'+companyId+'/publications/'+publication.id+'/form-submit';
        }
        break;
      case 'KEYPASS':
        route = 'root.company-guest.keypass.detail';
        break;
      case 'WALL':
        route = 'root.company-guest.wall.detail';
        break;
      case 'PLANT':
        route = 'root.company-guest.plant.detail';
        break;
      case 'CUSTOMER_ADAPTION':
        route = 'root.company-guest.customer-adaption.detail';
        break;
      case 'ENGINE_MODEL':
        route = 'root.company-guest.engine-model.detail';
        break;
      case 'PUBLICATION_GROUP':
        route = 'root.company-guest.publication-group.detail';
        break;
      case 'ORDER':
        route = 'root.company-guest.order.detail';
        break;
      case 'COMPANY_ORDER':
        route = '';
        window.location.href = '/order/'+companyId+'/detail/'+publication.id;
        break;
      case 'ORDER_SUBCRIPTION':
        route = '';
        window.location.href = '/order/'+companyId+'/subcription-detail/'+publication.id;
        break;
      case 'BLOG':
        route = 'root.company-guest.blog.detail';
        break;
      case 'SK3_FOLDER':
        route = 'root.company-guest.sk3-folder.detail';
        break;
      default:
        route = 'root.company-guest.publications.detail';
    }
    if(route){
      $state.go(route, {companyId: companyId, publicationId: publication.id});
    }
  };

  $scope.getPublicationIcon = function(type) {
    switch(type) {
      case 'DEFAULT':              return 'fa-files-o';
      case 'FOLDER':               return 'fa-briefcase';
      case 'ALBUM':                return 'fa-image';
      case 'FORM':                 return 'fa-clipboard';
      case 'NOTE':                 return 'fa-file-text-o';
      case 'KEYPASS':              return 'fa-key';
      case 'WALL':                 return 'fa-comments-o';
      case 'PLANT':                return 'fa-industry';
      case 'CUSTOMER_ADAPTION':    return 'fa-cogs';
      case 'ENGINE_MODEL':         return 'fa-folder';
      case 'PUBLICATION_GROUP':    return 'fa-object-group';
      case 'ORDER':                return 'fa-list';
      case 'COMPANY_ORDER':        return 'fa-shopping-cart';
      case 'BLOG':                  return 'fa-blog';
      case 'SK3_FOLDER':                  return 'fa-lock';
    }
  };

  $scope.toggleTag = function(tag) {
    if (-1 === $scope.publicationQuery.tags.indexOf(tag)) {
      $scope.publicationQuery.tags.push(tag);
    } else {
      $scope.publicationQuery.tags.splice($scope.publicationQuery.tags.indexOf(tag), 1);
    }
  };

  $scope.$on('$stateChangeSuccess', function(event, toState, toParams) {
    for (var attr in $scope.publicationQuery) {
      if($scope.publicationQuery.hasOwnProperty(attr)) {
        if('tags' === attr) {
          if(!toParams[attr]) {
            $scope.publicationQuery[attr] = [];
            continue;
          }

          $scope.publicationQuery[attr] = toParams[attr].split(',');
        } else {
          $scope.publicationQuery[attr] = toParams[attr];
        }
      }
    }

  });

  $scope.$on('categoriesChanged', function(ev, categories) {
    if(categories) {
      $scope.categories = categories;
    } else {
      CompanyCategoryService.query({companyId: company.id}, function(categories) {
        $scope.categories = categories;
      });
    }
  });

  var reloadTagsTimeout;
  $scope.$on('tagsChanged', function() {
    if(reloadTagsTimeout) {
      $timeout.cancel(reloadTagsTimeout);
      reloadTagsTimeout = null;
    }
    reloadTagsTimeout = $timeout(function() {
      CompanyService.queryTags({companyId: company.id}, function(tags) {
        $scope.tags = tags;
      });
    }, 1000 * 61);
  });

  var searchTimeout;
  $scope.filterPublications = function() {
    if(searchTimeout){
      $timeout.cancel(searchTimeout);
      searchTimeout = null;
    }
    searchTimeout = $timeout(function () {
      var q = angular.copy($scope.publicationQuery);

      // Remove tags from query string if it is empty
      if(q.tags && 0 === q.tags.length) {
        q.tags = null;
      }
      $state.go('root.company-guest.publications.list', q);
      searchTimeout = null;
    }, 200);
  };

  $scope.downloadZip = function(publicationId) {
    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (true === iOS) {
      window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/zip?lang=' + window.localStorage.language, '_self');
      return;
    }

    var elm = angular.element(document.querySelector('body'));
    var iFrame = elm.find('#downloadWindow');
    if (!(iFrame && iFrame.length > 0)) {
      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
      elm.append(iFrame);
    }
    iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/zip?lang=' + window.localStorage.language);
  };

  $scope.openPreview = function(file, publicationId) {
    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
        return $scope.download(file, publicationId);
      }

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;

      var type;
      switch(file.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          type = 'image';
          break;
        case 'application/pdf':
          if (true === iOS) {
            window.open(url, '_self');
            return;
          }
          type = 'iframe';
          break;
        default:
          type = 'iframe';
      }

      jQuery.fancybox.open([{
        type: type,
        iframe: {
          preload: false
        },
        padding: 0,
        margin: 0,
        href: url
      }]);
    });

    return false;
  };

  $scope.download = function(file, publicationId) {
    CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true', '_self');
        return;
      }
      
      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadWindow');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }

      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true');
    });
  };

  $scope.openNewWindow = function(menu){
    if(!menu.mainMenu){
      if(menu.targetBlank){
        $window.open(menu.guestLink, 'newwindow', 'width=1200, height=800');
      }else{
        $window.location.href = menu.guestLink;
      }
    }
    return false;
  };

}

var isGuestCompanyState = /^root\.company-guest(\..*|$)/i;

CompanyGuestCtrl.resolve = {
  company: ['$stateParams', 'stateSnapshot', '$state', 'CompanyService', function($stateParams, stateSnapshot, $state, CompanyService) {
    return CompanyService.get({
      companyId: $stateParams.companyId,
      leaveCompany: stateSnapshot.previous.params.companyId || null,
      enterCompany: true
    }).$promise.then(function(company) {
      if(company.userType !== "GUEST" && isGuestCompanyState.test(stateSnapshot.next.state.name)) {
        $state.go(stateSnapshot.next.state.name.replace(isGuestCompanyState, 'root.company$1-list'), stateSnapshot.next.params);

        /* Required to prevent anything depending on company
           from actually sending XHRs. */
        throw new Error("Restarting routing");
      }

      return company;
    });
  }],
  customerPortals: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, type: 'VISIBLE', userId: $window.localStorage.userId, all: true}).$promise;
  }],
  categories: ['$stateParams', 'CompanyCategoryService', function($stateParams, CompanyCategoryService){
    return CompanyCategoryService.query({companyId: $stateParams.companyId, nonEmpty: true}).$promise;
  }],
  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
  }],
  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService){
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
  }],
  role: ['CompanyUserRoleService', '$stateParams', 'userInformation', 'info', function(CompanyUserRoleService, $stateParams, userInformation, info){
      var selectedRole = null;
      if(userInformation.features.selectedRole){
        selectedRole = userInformation.features.selectedRole;
      }else if(userInformation.roles !== null && userInformation.roles[0]){
        selectedRole = userInformation.roles[0];
      }
      if (info.features.userRole && selectedRole) {
        return CompanyUserRoleService.get({
          companyId: $stateParams.companyId,
          roleId: selectedRole.id
        }).$promise;
      }
      return null;
  }],
  userGroups: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, type: null, userId: $window.localStorage.userId, all: true}).$promise;
  }]
};
module.exports = CompanyGuestCtrl;

angular.module('dokiv')
  .controller('CompanyGuestCtrl', [
    '$scope',
    'customerPortals',
    '$state',
    '$stateParams',
    '$timeout',
    '$modal',
    '$window',
    'config',
    'company',
    'categories',
    'userInformation',
    'info',
    'role',
    'userGroups',
    'CompanyCategoryService',
    'CompanyPublicationFileService',
    'CompanyService',
    CompanyGuestCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/CompanyGuestCtrl.js
// module id = 280
// module chunks = 0